import { CommonModule, NgOptimizedImage } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { PhoneOnlyDigitsPipe, PhonePipe } from "./pipes/phonenumber.pipe";
import { LoadingTextComponent } from "./components/loading-text/loading-text.component";
import { DateFromNowPipe as DateFromNowPipe } from "./pipes/dates.pipe";
import { OrderByPipe } from "./pipes/order.pipe";
import { LeadOptionsPickerComponent } from "./components/lead-options-picker/lead-options-picker.component";
import { NgxMaskDirective, provideNgxMask } from "ngx-mask";
import { LoadMoreOnViewDirective } from './directives/load-more-on-view.directive';
import { FileDropDirective } from './directives/file-drop.directive';
import { ClampToggleDirective } from "./directives/clamp-toggle.directive";
import { ColorFromTextDirective } from "./directives/color-from-text.directive";
import { InlineStatusIndicatorComponent } from "./components/inline-status-indicator/inline-status-indicator.component";

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule, 
    FormsModule, 
    NgbModule,
    NgOptimizedImage,
    NgxMaskDirective,
    PhonePipe,
    FaIconComponent,
    LoadingTextComponent,
    LoadMoreOnViewDirective,
    FileDropDirective,
    ClampToggleDirective,
    OrderByPipe,
    ColorFromTextDirective,
    InlineStatusIndicatorComponent
  ],
  exports: [
    CommonModule,
    NgOptimizedImage,
    ReactiveFormsModule, 
    FormsModule, 
    NgbModule,
    FaIconComponent,
    NgxMaskDirective,
    PhoneOnlyDigitsPipe,
    DateFromNowPipe,
    OrderByPipe,
    LoadingTextComponent,
    LeadOptionsPickerComponent,
    PhonePipe,
    LoadMoreOnViewDirective,
    FileDropDirective,
    ClampToggleDirective,
    ColorFromTextDirective,
    InlineStatusIndicatorComponent
  ],
  declarations: [
    PhoneOnlyDigitsPipe,
    DateFromNowPipe,
    LeadOptionsPickerComponent,
  ],
  providers: [provideNgxMask()]
  
})
export class SharedModule {}
